/**
 * @generated SignedSource<<726ed4899700ff7484b345b1bbb200f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionListTile_publicProfile$data = {
  readonly username: string | null;
  readonly " $fragmentType": "NftProfileImportCollectionListTile_publicProfile";
};
export type NftProfileImportCollectionListTile_publicProfile$key = {
  readonly " $data"?: NftProfileImportCollectionListTile_publicProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionListTile_publicProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionListTile_publicProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "type": "PublicProfile",
  "abstractKey": null
};

(node as any).hash = "c60d2e863e5acdbc8009754e8d5777d7";

export default node;
